export const detail = {
  table: {
    id: '順番',
    companyId: '納入先 CD',
    shortName: '略名',
    companyName: '会社名',
    createdAt: '作成日',
    washingMethodName: '洗浄プログラム名',
    time: '洗浄時間/分',
  },
  tableWashingMethod: {
    title: '洗浄プログラム',
  },
  pageHeader: {
    title: '顧客リスト　顧客詳細画面',
    titleWashingMethodList: '個人データの登録/編集',
  },
}
